'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var arrowDownMaterial = require('./arrow-down-material-25c60327.js');
var arrowUpMaterial = require('./arrow-up-material-44df9fc0.js');
var cell = require('./cell-96115b74.js');

var directionIcons = {
    asc: arrowUpMaterial.ArrowUpMaterial,
    desc: arrowDownMaterial.ArrowDownMaterial,
};
var HeaderSortButton = function (_a) {
    var active = _a.active, order = _a.order, rest = tslib_es6.__rest(_a, ["active", "order"]);
    return (active ? directionIcons[order](tslib_es6.__assign({}, rest)) : null);
};

var StyledCellContent = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var SortableHeader = function (_a) {
    var children = _a.children, order = _a.order, orderBy = _a.orderBy, onHeaderClick = _a.onHeaderClick, sortButtonProps = _a.sortButtonProps, headerProps = tslib_es6.__rest(_a, ["children", "order", "orderBy", "onHeaderClick", "sortButtonProps"]);
    var sortHandler = React.useCallback(function () {
        onHeaderClick(headerProps.id);
    }, [onHeaderClick, headerProps.id]);
    return (React__default.createElement(cell.Cell, tslib_es6.__assign({ onClick: sortHandler, variant: "header" }, headerProps),
        React__default.createElement(StyledCellContent, null,
            children,
            React__default.createElement(HeaderSortButton, tslib_es6.__assign({ order: order, active: headerProps.id === orderBy }, sortButtonProps)))));
};
var templateObject_1;

exports.SortableHeader = SortableHeader;
